import React, { useEffect, useRef, useState } from "react";
import styles from "./PaintersSection.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import ArtistCard from "components/cards/artistCard/ArtistCard";
import { paintings } from "mockdata/paintings";

const PaintersSection = ({ country }) => {
  const paintersWithArtworksRef = useRef();
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (paintersWithArtworksRef.current) {
      setMaxHeight(paintersWithArtworksRef?.current?.offsetHeight);
    }
  }, []);

  return (
    <div className={styles.paintersSection}>
      <div
        className={styles.paintersWithArtworks}
        ref={paintersWithArtworksRef}
      >
        <div className={styles.painterWithArtworksContainer}>
          <div className={styles.painterWithArtworks}>
            <ArtistCard />
            <ArtworkCard item={paintings[0]} />
            <ArtworkCard item={paintings[1]} />
          </div>
        </div>
        <div className={styles.painterWithArtworksContainer}>
          <div className={styles.painterWithArtworks}>
            <ArtistCard />
            <ArtworkCard item={paintings[2]} />
            <ArtworkCard item={paintings[3]} />
          </div>
        </div>
      </div>
      <div className={styles.paintersFromCountry}>
        <div className={styles.title}>Painters From {country}</div>
        {maxHeight ? (
          <div
            className={styles.paintersListContainer}
            style={{
              maxHeight: `${maxHeight}px`,
            }}
          >
            <div className={styles.paintersList}>
              {Array.from(Array(100), (_, index) => (
                <div className={styles.painter} key={index}>
                  Name Lastname
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PaintersSection;
